import Firebase from 'firebase'

const firebase = Firebase.initializeApp({
  apiKey: 'AIzaSyCoebrHrFivoWVvVqwswf5HYwB-YW9GcEI',
  authDomain: 'pokrzyk-plaid.firebaseapp.com',
  databaseURL: 'https://pokrzyk-plaid.firebaseio.com',
  projectId: 'pokrzyk-plaid',
  storageBucket: 'pokrzyk-plaid.appspot.com',
  messagingSenderId: '876934432144'
})

export const db = firebase.database()
export const auth = firebase.auth()

export function launchSignIn() {
  const provider = new Firebase.auth.GoogleAuthProvider()
  provider.addScope('profile')
  auth.signInWithRedirect(provider)
  auth.getRedirectResult()
}

export function command(payload) {
  payload.timestamp = Firebase.database.ServerValue.TIMESTAMP
  db.ref('commands').child(auth.currentUser.uid).push(payload)
}

export async function exchangeToken(publicToken) {
  const url =
    'https://us-central1-pokrzyk-plaid.cloudfunctions.net/exchangeToken'
  const body = {
    public_token: publicToken,
    uid: auth.currentUser.uid
  }

  const res = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-type': 'application/json'
    },
    mode: 'no-cors',
    body: JSON.stringify(body)
  })

  const ret = await res.text()
  console.log(ret)
  return ret
}



// WEBPACK FOOTER //
// ./src/api.js